import { Box, List, ListItem, ListItemButton, Typography, styled } from '@mui/material'
import React, { useContext } from 'react'
import DrawerCard from './DrawerCard'
import { TextSizeContext } from 'data/index'
import { useTranslation } from 'react-i18next'
import { TextSizes } from 'entities/constants'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { IconButton } from '@mui/material';


const Wrapper = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'collapsed'
})<{ collapsed?: boolean }>(({ theme, collapsed }) => ({
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: collapsed ? '3.5rem' : '17.62rem',   // Breite dynamisch!
    transition: 'width 0.3s cubic-bezier(.4,0,.2,1)',
    flexShrink: 0,
    overflowY: "auto",
    "&::-webkit-scrollbar": {
        width: "0.2rem",
        height: '0.2rem',
    },
    "&::-webkit-scrollbar-track": {
        background: 'transparent',
    },
    "&::-webkit-scrollbar-thumb": {
        background: theme.palette.primary.dark,
        borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
        background: theme.palette.grey[700],
    },
}));


const ListElement = styled(ListItem)<{ active?: string }>(({ theme, active }) => ({
    padding: 0,
    backgroundColor: active ? theme.palette.grey[800] : 'none',
    borderRight: `3px solid ${active ? theme.palette.primary.main : 'transparent'}`,
}))


const ListButton = styled(ListItemButton)(() => ({
    height: '6.25rem',
    padding: '4px 0px 4px 20px',
    justifyContent: 'space-between',
}))

const ListBox = styled(Box)(() => ({
    display: 'flex',
    flexGrow: 1,
    height: '6.25rem',
    padding: '4px 0px 4px 20px',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
}))

const TitleBox = styled(Box)(() => ({
    height: '5rem',
    width: '100%',
    padding: '4px 20px',
    display: 'flex',
    alignItems: 'center'
}))

const Drawer = ({ active, setActive, options, title, menu = [], isSettings = false, collapsed = false, setCollapsed }: any) => {
    const { t } = useTranslation()
    const { state: textSize } = useContext(TextSizeContext)

return (
  <Wrapper collapsed={collapsed} >
    {collapsed ? (
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          minHeight: '3.5rem',
          marginTop: '5rem',
          justifyContent: 'center',
        
        }}
      >
        <IconButton
          onClick={() => setCollapsed && setCollapsed(false)}
          size="small"
        >
          <ChevronRightIcon />
        </IconButton>
      </Box>
    ) : (
      <>
        <TitleBox sx={{marginTop: '5rem'}}>
          <Typography fontSize={TextSizes[textSize].title2} fontWeight="bold">
            {"Skills"}
          </Typography>
          <IconButton
            onClick={() => setCollapsed && setCollapsed(true)}
            size="small"
            sx={{ marginLeft: 'auto' }}
          >
            <ChevronLeftIcon />
          </IconButton>
        </TitleBox>
        <List>
          {options.map((option: any) => (
            <ListElement key={option.title} active={option.title === active.title ? 'true' : undefined}>
              {option.title === active.title ? (
                <ListBox onClick={() => setActive(option)}>
                  <DrawerCard
                    courseId={option.id}
                    label={option.title}
                    image={option.thumbnail}
                    imageDark={option.thumbnailDark}
                    progress={option.progress}
                    active={option.title === active.title}
                    menu={menu}
                    isSettings={isSettings}
                    collapsed={collapsed}
                  />
                </ListBox>
              ) : (
                <ListButton onClick={() => setActive(option)}>
                  <DrawerCard
                    courseId={option.id}
                    label={option.title}
                    image={option.thumbnail}
                    imageDark={option.thumbnailDark}
                    progress={option.progress}
                    active={option.title === active.title}
                    menu={menu}
                    isSettings={isSettings}
                    collapsed={collapsed}
                  />
                </ListButton>
              )}
            </ListElement>
          ))}
        </List>
      </>
    )}
  </Wrapper>
);

}

export default Drawer